var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","column":""}},[_c('img',{staticClass:"Hero",attrs:{"src":require("../../assets/HubungiKami/Hero-mobile.svg")}}),_c('p',{staticClass:"Text-Hero"},[_vm._v(" Get In Touch ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }